import React from 'react';
import Frame from '../../views/Frame';

import Texts from '../../../data/texts.json';
import Extras from '../../../data/extras.json';

import createSprite from '../../../lib/createSprite';
import spritesHelper from '../../../lib/spritesHelper';
import Utils from '../../../lib/utils';

// import Audio from '../../../lib/audio';

import CommonAnimations from '../../../animations/common';

var Title = React.createClass({

    propTypes: {
        backgroundKey: React.PropTypes.string,
        className: React.PropTypes.string
    },

    contextTypes: {
        language: React.PropTypes.string,
    },

    timeline: null,
    sprites: null,

    getDefaultProps: function()
    {
        var texts = _.get(Texts, 'scenes.intro');
        var bottomTexts = _.get(texts, 'bottomText');

        return {
            backgroundKey: 'introBg',
            layers: [
                {
                    backgroundKey: 'pipes',
                },
                {
                    backgroundKey: 'darkLinesBackground',
                },
            ],

            className: 'intro-title',
            portraitKeys: ['agent', 'mom', 'dad', 'charles', 'lady', 'baldGuy'],
            bottomTile: true,
            bottomTileColor: 'green',

            audioUrls: {
                // title: '/audio/28nov/general-ambiance-niveau-01-27nov.mp3'
            },
        };
    },

    render: function()
    {
        var context = this.context;
        var props = this.props;

        var homepage = Extras.homepage.text[context.language] || '';
        var prefix = Extras.leon_intro_with.text[context.language] || '';
        var name = Extras.leon_intro_name.text[context.language] || '';
        var title = Extras.leon_intro_title.text[context.language] || '';

        return (
            <Frame
                onBuild={this.build}
                onPlay={this.play}
                onPause={this.pause}
                onDestroy={this.destroy}
                {...props}
            >
                <div className="subtitle" dangerouslySetInnerHTML={{__html: homepage}} />
                <div className="leon-text">
                    <span className="prefix" dangerouslySetInnerHTML={{__html: prefix}} />
                    <span className="name" dangerouslySetInnerHTML={{__html: name}} />
                    <div className="title" dangerouslySetInnerHTML={{__html: title}} />
                </div>
            </Frame>
        );
    },

    build: function(container, timeline)
    {
        this.sprites = {
            container: container,
        };
        this.timeline = timeline;

        this.buildObjects();
        this.animateObjects();

        // Audio
        this.audios = {};
        // _.forOwn(this.props.audioUrls, (value, key) => {
        //     this.audios[key] = new Audio(value, {
        //         loop: true,
        //         volume: 0.5,
        //     });
        // });
    },

    play: function()
    {
        // if (this.audios.title) {
        //     this.audios.title.play();
        // }
    },

    pause: function()
    {
        // if (this.audios.title) {
        //     this.audios.title.fade(0.5, 0.2);
        // }
    },

    destroy: function()
    {
        // console.log('destroy', this.props.objs, this.sprites);

        this.sprites = null;
        this.audios = null;
    },

    buildObjects: function()
    {
        var props = this.props;
        var sprites = this.sprites;
        var objs = props.objs;
        var container = sprites.container;

        var width = props.width;
        var height = props.height;

        var devObj = objs.dev;
        // var dev = sprites.dev = createSprite(devObj);
        // Utils.setSizeAndPositionFromRefSize(dev, props.width, props.height, devObj);
        // dev.alpha = 0;

        // PIPES -------------------------------------------
        var pipesObj = objs.pipes;
        var pipes = sprites.pipes = createSprite(pipesObj);
        Utils.setSizeAndPositionFromRefSize(pipes, props.width, props.height, pipesObj);
        container.addChild(pipes);

        // console.log('mobile', this.props)

        var portraitsContainer = new PIXI.Container();
        if (this.props.device === 'phone') {
            portraitsContainer.position.x = 3;
            portraitsContainer.position.y = 10;
            portraitsContainer.scale.x = 0.95;
            portraitsContainer.scale.y = 0.95;
        }

        // PORTRAITS ---------------------------------------
        _.each(props.portraitKeys, _.bind(function(portraitKey){
            sprites[portraitKey+'Portrait'] = this.createAnimatedPortrait(portraitKey);
            portraitsContainer.addChild(sprites[portraitKey+'Portrait']);
        }, this));

        container.addChild(portraitsContainer);

        // Text
        var textContainer = new PIXI.Container();

        // STAR --------------------------------------------
        var starTextureObj = objs.starTexture;
        var starTexture = sprites.starTexture = createSprite(starTextureObj);
        Utils.setSizeAndPositionFromRefSize(starTexture, props.width, props.height, starTextureObj);

        var starMaskObj = objs.starMask;
        var starMask = sprites.starMask = createSprite(starMaskObj);
        Utils.setSizeAndPositionFromRefSize(starMask, props.width, props.height, starMaskObj);

        if (props.rendererType !== 'canvas') {
            starTexture.mask = starMask;
            textContainer.addChild(starMask);
            textContainer.addChild(starTexture);
        }

        // TITLE -------------------------------------------
        var titleTextTextureObj = objs.titleTextTexture;
        var titleTextTexture = sprites.titleTextTexture = createSprite(titleTextTextureObj);
        titleTextTextureObj.offsetY = -80;
        Utils.setSizeAndPositionFromRefSize(titleTextTexture, props.width, props.height, titleTextTextureObj);

        var lang = this.context.language === 'en' ? '' : 'Fr';

        var titleTextMaskObj = objs['titleTextMask'+lang];
        var titleTextMask = sprites['titleTextMask'+lang] = createSprite(titleTextMaskObj);
        Utils.setSizeAndPositionFromRefSize(titleTextMask, props.width, props.height, titleTextMaskObj);

        if (props.rendererType !== 'canvas') {
            textContainer.addChild(titleTextTexture);
            titleTextTexture.mask = titleTextMask;
            textContainer.addChild(titleTextMask);
        } else {
            var titleTextObj = objs['titleText'+lang];
            var titleText = sprites['titleText'+lang] = createSprite(titleTextObj);
            Utils.setSizeAndPositionFromRefSize(titleText, props.width, props.height, titleTextObj);
            textContainer.addChild(titleText);
        }

        // DIRT --------------------------------------------
        var dirtObj = objs.dirt;
        var dirt = sprites.dirt = createSprite(dirtObj);
        Utils.setSizeAndPositionFromRefSize(dirt, props.width, props.height, dirtObj);

        if (props.rendererType !== 'canvas') {
            container.addChild(dirt);
        }

        container.addChild(textContainer);
    },

    createAnimatedPortrait: function(key)
    {
        var props = this.props;
        var width = props.width;
        var height = props.height;
        var objs = props.objs;
        var sprites = this.sprites;

        var frameObj = objs[key+'Frame'];
        var faceObj = objs[key+'Face'];

        var container = new PIXI.Container();
        var face = createSprite(faceObj);
        var frame = createSprite(frameObj);
        Utils.setSizeAndPositionFromRefSize(frame, props.width, props.height, frameObj);
        Utils.setSizeAndPositionFromRefSize(face, frame.width, frame.height, faceObj);
        face.x += frame.x;
        face.y += frame.y;
        face.name = 'face';
        container.addChild(frame);
        container.addChild(face);

        return container;
    },

    animateObjects: function()
    {
        var props = this.props;
        var context = this.context;
        var sprites = this.sprites;
        var objects = props.objs;

        var width = props.width;
        var height = props.height;

        var timeline = this.timeline;

        var lang = this.context.language === 'en' ? '' : 'Fr';

        // PIPES --------------------------------------
        timeline.add(new TimelineMax({repeat: -1, repeatDelay: 1})
            .to(sprites.pipes, 0.01, {
                repeat: 120,
                yoyo: true,
                x: '+='+width * 0.004,
        }), 0);

        // PORTRAITS ----------------------------------
        _.each(props.portraitKeys, function(portraitKey, i){
            var portraitFace = sprites[portraitKey+'Portrait'].getChildByName('face');
            timeline.add(CommonAnimations.getMovieclipTimeline(portraitFace, {
                fps: 0.5
            }), i * 0.22);
        });

        // STAR ---------------------------------------
        timeline.to(sprites.starMask.scale, 1, {
            x: '-=0.1',
            y: '-=0.1',
            ease: Power1.easeInOut,
            yoyo: true,
            repeat: -1
        }, 0);

        // TITLE --------------------------------------
        timeline.to(sprites.titleTextTexture, 4, {
            repeat: -1,
            yoyo: true,
            ease: Quad.easeInOut,
            y: '-=' + ((height * 0.25)),
        }, 0);

        console.log('height', height, this.props);

        if (this.props.onAnimationReady) {
            this.props.onAnimationReady(timeline);
        }
    }

});

module.exports = Title;



// WEBPACK FOOTER //
// ./js/components/frames/0-Intro/1-Title.jsx